import { Box, Button, IconButton, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { icons } from "../../../../utils/icons"
import { useTranslation } from "react-i18next"
import { ObjectGeneric, onChange, Table } from "../../../../utils/types/generals"
import { createRef, useEffect, useRef, useState } from "react"
import { initialFilterValues, initialTable, inputModel } from "../main/initialState"
import { SectionType } from "./enums"
import { useContextState } from "../../../../hooks/theme"
import { SelectTables } from "./components/selectTables"
import { filterRow, getQuestionnarie, getStores } from "../main/methods"
import { ConfigCalendarSerie } from "./components/configCalendarSerie"
import { DaysWeek } from "../../../reportFolio/pages/notifications/pages/main/utils/enums/tabs"
import dayjs from "dayjs"
import { toUnitTimeZone } from "../../../../utils/methods/calcDate"
import { Constants } from "../../../../utils/constants"
import { scheduleServiceFetch, storeServices } from "../../../../utils/constants/callService"
import { InputModel } from "../../../../utils/types"
import { DateModalRangeRef } from "../../../../components/dinamicForm/dateModal"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { FrequencyEnum, ScheduleEnumType } from "../form/components/steps/configCalendar/enums"
import Loader from "../../../../components/loader"
import { formatresponseSchedule } from "./response"
import SimpleModal from "../../../../components/modal/simpleModal"
import { daysOfWeek } from "../form/constans/inputs"
import { formatDataToEndoint } from "./format"
import { ScheduleService } from "../../../../service/schedule"
import { httpFetch } from "../../../../utils/crud"
import { RequestErrors, Types } from "../../../../utils/enums"
import { SnackSimple } from "../../../../components"
import { handleAllErrors } from "../../../../utils/methods/handleErrors"
import { getLocalStorage } from "../../../../utils/crud/crypt"
import { eachDayOfInterval } from "date-fns"



const EditSerie = () => {

    const styles = useStyles()
    const { t } = useTranslation()
    const [data, setData] = useState<ObjectGeneric>({})
    const [errors, setErrors] = useState<Record<string, string>>({})
    const [selectedDays, setSelectedDays] = useState<number[]>([DaysWeek.MONDAY, DaysWeek.TUESDAY, DaysWeek.WEDNESDAY, DaysWeek.THURSDAY, DaysWeek.FRIDAY, DaysWeek.SATURDAY, DaysWeek.SUNDAY])
    const location = useLocation();
    const navigate = useNavigate()
    const { id } = useParams()
    const option: ScheduleEnumType = location.state?.option;
    const idQuestionarie: number = location.state?.assignedQuestionnaireId;
    const [flagStore, setFlagStore] = useState(false)
    const [section, setSection] = useState(SectionType.IndexSerie)
    const [startDate, setStartDate] = useState<number | undefined>(undefined)
    const [mimTimeZone, setmimTimeZone] = useState(Constants.defaultTimeZoneObject)
    const refRange = createRef<DateModalRangeRef>()
    const { colors } = useContextState()

    const [hasInitialized, setHasInitialized] = useState(true);

    const didInitRef = useRef(false);

    const [tableStores, setTableStores] = useState<Table>(initialTable)
    const [tableQuestionnarie, setTableQuestionnarie] = useState<Table>(initialTable)
    const [isLoading, setIsLoading] = useState(false)
    const [loadingLocal, setLoadingLocal] = useState(false)
    const [loadSubmit, setLoadSubmit] = useState(false)
    const state: { id: number, firstName: string, lastName: string } = getLocalStorage()
    const [selected, setSelected] = useState<{ stores: number[]; questionnaire: number[] }>({ stores: [], questionnaire: [] })
    const [selectedText, setSelectedText] = useState<{ stores: string; questionnaire: string }>({ stores: '', questionnaire: '' })
    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })

    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void
        isLoading: boolean
    }>({
        open: false,
        title: '',
        confirm: () => { },
        isLoading: false
    })

    const closeModal = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    const handleCloseSnackbar = (value: boolean) => setOpenSnackbar({ ...openSnackbar, open: value })

    const formatSelectedDays = (selectedDays: number[]): string => {
        const labels = daysOfWeek
            .filter(day => selectedDays.includes(day.value))
            .map(day => day.label);

        if (labels.length === 0) return '';
        if (labels.length === 1) return labels[0];
        if (labels.length === 2) return `${labels[0]} y ${labels[1]}`;

        const allButLast = labels.slice(0, -1).join(', ');
        const last = labels[labels.length - 1];
        return `${allButLast} y ${last}`;
    };

    const assignedChildren = () => {
        let newChilds: string[] = [];
        let description = '';

        if (option == ScheduleEnumType.UNIQUE) {
            description = t('schedule.modal.saveConfiguration');
        }

        if (option == ScheduleEnumType.SERIE) {
            description = t('schedule.modal.areYouSureToEditThisSerie');
        }

        if (option == ScheduleEnumType.RECURRENT) {
            description = t('schedule.modal.areYouSureToEditThisSchedule');
        }

        if (option == ScheduleEnumType.UNIQUE || option == ScheduleEnumType.SERIE) {
            if (!!data.openQuestionnaire) {
                newChilds = [
                    t('schedule.assigned.freeScheduling')
                ];

            } else {
                if (data.frequency == FrequencyEnum.UNIQUE) {
                    const fechaFrom = dayjs(data.from).format(Constants.dayjsFormatDate);
                    const horaFrom = dayjs(data.from).format(Constants.dayjsFormatTime);
                    const parsedHoraFrom = dayjs(horaFrom, 'hh:mm A');
                    const horaFromParse = parsedHoraFrom.hour() % 12 || 12;
                    const isHoraFromOne = horaFromParse === 1;
                    const fechaTo = dayjs(data.to).format(Constants.dayjsFormatDate);
                    const horaTo = dayjs(data.to).format(Constants.dayjsFormatTime);
                    const parsedHoraTo = dayjs(horaTo, 'hh:mm A');
                    const horaToParse = parsedHoraTo.hour() % 12 || 12;
                    const isHoraToOne = horaToParse === 1;
                    newChilds = [
                        t('schedule.assigned.singlSscheduling'),
                        isHoraFromOne && isHoraToOne ?
                            t('schedule.assigned.availablefromOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                            :
                            isHoraFromOne && !isHoraToOne ?
                                t('schedule.assigned.availablefromOnlyOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                                :
                                !isHoraFromOne && isHoraToOne ?
                                    t('schedule.assigned.availablefromOnlyTwo', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                                    :
                                    t('schedule.assigned.availablefromTow', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                    ];
                }

                if (data.frequency == FrequencyEnum.DAYLI) {
                    const fechaFrom = dayjs(data.fromDateDaily).format(Constants.dayjsFormatDate);
                    const horaFrom = dayjs(data.startDateDaily).format(Constants.dayjsFormatTime);
                    const fechaTo = dayjs(data.toDateDaily).format(Constants.dayjsFormatDate);
                    const horaTo = dayjs(data.endDateDaily).format(Constants.dayjsFormatTime);
                    const days = formatSelectedDays(selectedDays);

                    const parsedHoraFrom = dayjs(horaFrom, 'hh:mm A');
                    const horaFromParse = parsedHoraFrom.hour() % 12 || 12;
                    const isHoraFromOne = horaFromParse === 1;
                    const parsedHoraTo = dayjs(horaTo, 'hh:mm A');
                    const horaToParse = parsedHoraTo.hour() % 12 || 12;
                    const isHoraToOne = horaToParse === 1;
                    newChilds = [
                        t('schedule.assigned.dailyScheduling'),
                        isHoraFromOne && isHoraToOne ?
                            t('schedule.assigned.availableEveryDayFromOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                            :
                            isHoraFromOne && !isHoraToOne ?
                                t('schedule.assigned.availableEveryDayFromOnlyOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                                :
                                !isHoraFromOne && isHoraToOne ?
                                    t('schedule.assigned.availableEveryDayFromOnlyTwo', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                                    :
                                    t('schedule.assigned.availableEveryDayFromTwo', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo }),
                        t('schedule.assigned.generatedEveryEdit', { days: days }),
                        t('schedule.assigned.initialGenerationEdit', { startDate: fechaFrom, endDate: fechaTo })
                    ];
                }

                if (data.frequency == FrequencyEnum.WEEKLY) {
                    const fechaFrom = dayjs(data.fromDateWeekly).format(Constants.dayjsFormatDate);
                    const fechaTo = dayjs(data.toDateWeekly).format(Constants.dayjsFormatDate);
                    const fechaFromDate = dayjs(data.fromDateWeekly).toDate();
                    const fechaToDate = dayjs(data.toDateWeekly).toDate();
                    const days = formatSelectedDays(selectedDays);
                    const dayNumber = Number(data.duration.replace(/\D/g, ''));
                    const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
                    const arrayDays = eachDayOfInterval({
                        start: fechaFromDate,
                        end: fechaToDate,
                    })
                    const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                    const dayLetter = daysOfWeek
                        .filter(day => day.value == data.dayOfWeek)
                        .map(day => day.label);
                    newChilds = [
                        t('schedule.assigned.weeklyScheduling'),
                        t('schedule.assigned.eachSchedulingAvailableDuring', { count: dates.length, dayAvailable: dates.length, days: days }),
                        t('schedule.assigned.generatedEveryFromEdit', { day: dayLetter, startDate: fechaFrom, endDate: fechaTo })
                    ];
                }

                if (data.frequency == FrequencyEnum.CYCLIC) {
                    const fechaFrom = dayjs(data.fromDateCycli).format(Constants.dayjsFormatDate);
                    const fechaTo = dayjs(data.toDateCycli).format(Constants.dayjsFormatDate);
                    const fechaFromDate = dayjs(data.fromDateCycli).toDate();
                    const fechaToDate = dayjs(data.toDateCycli).toDate();
                    const days = formatSelectedDays(selectedDays);
                    const dayNumber = Number(data.duration.replace(/\D/g, ''));
                    const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
                    const arrayDays = eachDayOfInterval({
                        start: fechaFromDate,
                        end: fechaToDate,
                    })
                    const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                    newChilds = [
                        t('schedule.assigned.cyclicalScheduling'),
                        t('schedule.assigned.eachSchedulingAvailableDuring', { count: dates.length, dayAvailable: dates.length, days: days }),
                        t('schedule.assigned.generatedConsecutivelyEdit', { startDate: fechaFrom, endDate: fechaTo })
                    ];
                }
            }
        }
        //childrenRef.current = !!data.openQuestionnaire ? ['', ...newChilds] : newChilds;
        //setChildren(newChilds)
        setModal(prev => ({
            ...prev,
            open: true,
            confirm: () => {
                handleConfirm()
                //closeModal()
            },
            isLoading: true,
            title: t('schedule.modal.confirmation'),
            description: undefined,
            children: option == ScheduleEnumType.RECURRENT ?
                <Box sx={styles.containerChild}>
                    <Typography className="title_text" /* variant='text_grey' */ fontSize={14}>{description}</Typography>
                </Box>
                :
                <Box sx={styles.containerChild}>
                    <Typography className="title_text" /* variant='text_grey' */ fontSize={14}>{description}</Typography>
                    <Box >

                        {newChilds.map((child, index) => (
                            <Box sx={{ display: 'flex' }}>
                                <Box sx={styles.containerCircle}>
                                    <Box sx={styles.circle} />
                                </Box>

                                <Typography sx={styles.textList} fontSize={14}>
                                    {child}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
        }))

    }


    const onChange: onChange = ({ target }) => {
        const { name, value } = target
        let body = { ...data }
        body = {
            ...data,
            [name]: value,
        }
        /* if (name == 'openQuestionnaire' && !value) {
            body.from = dayjs().tz(mimTimeZone.code)
            body.to = null
        } */

        if (name === 'frequency') {
            body = { ...body, every: null }
            setHasInitialized(false);
            setErrors(prev => ({
                ...prev,
                days: ''
            }))
        }

        if (name === 'dayOfWeek') {
            //const day = dayjs(fromDateDaily).day();
            setStartDate(value)
        }

        if (name === 'duration') {
            const soloNumeros = value?.replace(/\D/g, "");
            let errorMessage = '';
            if (soloNumeros < 1 && !!value) {
                errorMessage = t('general.validations.minimusOneDayToDuration');
            }
            setErrors(prev => ({
                ...prev,
                duration: errorMessage
            }))
        }
        if (['from', 'to'].includes(name)) {
            const from = name == 'from' ? value : data.from
            const to = name == 'to' ? value : data.to
            const frequency = data.frequency

            if (frequency == FrequencyEnum.DAYLI && option == ScheduleEnumType.RECURRENT) {
                if (Boolean(to)) {
                    let errorMessage = ''
                    if (dayjs(to).isBefore(dayjs(from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
                    //if (dayjs(to).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
                    if (dayjs(to).isAfter(dayjs(from).add(24, 'hour'))) { errorMessage = t('general.validations.maximum24Hours'); }
                    setErrors(prev => ({
                        ...prev,
                        to: errorMessage
                    }))
                }
            } else {
                if (Boolean(to)) {
                    let errorMessage = ''
                    if (dayjs(to).isBefore(dayjs(from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
                    if (dayjs(to).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
                    setErrors(prev => ({
                        ...prev,
                        to: errorMessage
                    }))
                }
            }


        }

        if (['startDateDaily', 'endDateDaily'].includes(name)) {
            const startDateDaily = name == 'startDateDaily' ? value : data.startDateDaily
            const endDateDaily = name == 'endDateDaily' ? value : data.endDateDaily

            if (Boolean(endDateDaily)) {
                let errorMessage = ''
                const start = dayjs(startDateDaily);
                const end = dayjs(endDateDaily);
                const diffInMinutes = end.diff(start, 'minute');
                if (diffInMinutes <= 5) { errorMessage = t('general.validations.minimus5minute') }
                setErrors(prev => ({
                    ...prev,
                    endDateDaily: errorMessage
                }))
            }
        }

        if (['fromDateDaily', 'toDateDaily'].includes(name)) {
            const fromDateDaily = name == 'fromDateDaily' ? value : data.fromDateDaily
            const toDateDaily = name == 'toDateDaily' ? value : data.toDateDaily

            if (Boolean(fromDateDaily)) {
                const day = dayjs(fromDateDaily).day();
                setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
            }

            if (Boolean(toDateDaily)) {
                let errorMessage = ''
                const start = dayjs(fromDateDaily);
                const end = dayjs(toDateDaily);
                const diffInDays = end.diff(start, 'day');
                if (diffInDays < 1) { errorMessage = t('general.validations.minimus1Day') }
                setErrors(prev => ({
                    ...prev,
                    toDateDaily: errorMessage
                }))
            }
        }

        if (['fromDateWeekly', 'toDateWeekly'].includes(name)) {
            const fromDateWeekly = name == 'fromDateWeekly' ? value : data.fromDateWeekly
            const toDateWeekly = name == 'toDateWeekly' ? value : data.toDateWeekly
            /* if (Boolean(fromDateWeekly)) {
                const day = dayjs(fromDateWeekly).day();
                setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
            } */
            if (Boolean(toDateWeekly)) {
                let errorMessage = ''
                const start = dayjs(fromDateWeekly);
                const end = dayjs(toDateWeekly);
                const diffInDays = end.diff(start, 'day');
                if (diffInDays < 7) { errorMessage = t('general.validations.minimus7Day') }
                setErrors(prev => ({
                    ...prev,
                    toDateWeekly: errorMessage
                }))
            }
        }

        if (['fromDateCycli', 'toDateCycli'].includes(name)) {
            const fromDateCycli = name == 'fromDateCycli' ? value : data.fromDateCycli
            const toDateCycli = name == 'toDateCycli' ? value : data.toDateCycli

            if (Boolean(fromDateCycli)) {
                const day = dayjs(fromDateCycli).day();
                setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
            }

            if (Boolean(toDateCycli)) {
                let errorMessage = ''
                const start = dayjs(fromDateCycli);
                const end = dayjs(toDateCycli);
                const diffInDays = end.diff(start, 'day');
                if (diffInDays < 1) { errorMessage = t('general.validations.minimus1Day') }
                setErrors(prev => ({
                    ...prev,
                    toDateCycli: errorMessage
                }))
            }
        }

        if (['fromDateDaily', 'toDateDaily', 'days'].includes(name)) {
            const fromDateCycli = name == 'fromDateDaily' ? value : data.fromDateDaily
            const toDateCycli = name == 'toDateDaily' ? value : data.toDateDaily
            const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
            let errorMessage = ''
            let flag: boolean = true;
            if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
                let current = dayjs(fromDateCycli)
                const end = dayjs(toDateCycli)

                while (current.isSame(end) || current.isBefore(end)) {
                    const dayOfWeek = current.day()
                    if (newSelectedDays.includes(dayOfWeek)) {
                        flag = false;
                    }
                    current = current.add(1, 'day')
                }

                if (flag) { errorMessage = t('general.validations.daysArentValid') }
                setErrors(prev => ({
                    ...prev,
                    days: errorMessage
                }))
            }
        }
        if (['fromDateCycli', 'toDateCycli', 'days', 'duration'].includes(name)) {
            const fromDateCycli = name == 'fromDateCycli' ? value : data.fromDateCycli
            const toDateCycli = name == 'toDateCycli' ? value : data.toDateCycli
            const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
            const duration = name == 'duration' ? value.replace(/[a-zA-Z]/g, '') : data.duration?.replace(/[a-zA-Z]/g, '');
            let errorMessage = ''
            let secondErrorMessage = ''
            let flag: boolean = true;
            if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
                let current = dayjs(fromDateCycli)
                const end = dayjs(toDateCycli)

                while (current.isSame(end) || current.isBefore(end)) {
                    const dayOfWeek = current.day()
                    if (newSelectedDays.includes(dayOfWeek)) {
                        flag = false;
                    }
                    current = current.add(1, 'day')
                }

                if (flag) { errorMessage = t('general.validations.daysArentValid') }

                const startToValidate = dayjs(fromDateCycli).toDate();
                const endToValidate = dayjs(toDateCycli).toDate();

                const arrayDays = eachDayOfInterval({
                    start: startToValidate,
                    end: endToValidate,
                })
                const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                if (duration > dates.length) {
                    secondErrorMessage = t('general.validations.isUnderTheDatesRange')
                }

                setErrors(prev => ({
                    ...prev,
                    days: errorMessage,
                    duration: secondErrorMessage
                }))
            }
        }

        if (['fromDateWeekly', 'toDateWeekly', 'duration', 'days'].includes(name)) {
            const fromDateCycli = name == 'fromDateWeekly' ? value : data.fromDateWeekly
            const toDateCycli = name == 'toDateWeekly' ? value : data.toDateWeekly
            const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
            const duration = name == 'duration' ? value.replace(/[a-zA-Z]/g, '') : data.duration?.replace(/[a-zA-Z]/g, '');
            let secondErrorMessage = ''
            if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
                const startToValidate = dayjs(fromDateCycli).toDate();
                const endToValidate = dayjs(toDateCycli).toDate();

                const arrayDays = eachDayOfInterval({
                    start: startToValidate,
                    end: endToValidate,
                })
                const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                if (duration > dates.length) {
                    secondErrorMessage = t('general.validations.isUnderTheDatesRange')
                }

                setErrors(prev => ({
                    ...prev,
                    duration: secondErrorMessage
                }))
            }


        }

        setData(prev => ({ ...prev, ...body }))
    }

    const loadData = async () => {
        setLoadingLocal(true)
        const response = await scheduleServiceFetch.getScheduleById(Number(id), idQuestionarie)
        setLoadingLocal(false)
        setSelected({ questionnaire: [response.assignedQuestionnaires[0].questionnaireMainData.id], stores: [response.store.id] })
        formatresponseSchedule({ mimTimeZone, option, setErrors, t, response, setData, setSelectedDays, setStartDate })
    }



    const handleConfirm = async () => {
        setLoadSubmit(true)
        const body = formatDataToEndoint({ data, selectedDays, selected, option })
        let response;
        if (option == ScheduleEnumType.UNIQUE) {
            response = await ScheduleService(httpFetch).updateSchedule(body[0], Number(id));
        }

        if (option == ScheduleEnumType.RECURRENT) {
            response = await ScheduleService(httpFetch).updateScheduleRecurrent(body[0], Number(id));
        }

        if (option == ScheduleEnumType.SERIE) {
            response = await ScheduleService(httpFetch).updateScheduleSerie(body[0], Number(data.serieId));
        }

        //response= await ScheduleService(httpFetch).updateSchedule(body[0], Number(id));
        if (response?.errors) {
            setOpenSnackbar({ ...openSnackbar, open: true, message: handleAllErrors(response.errors[0].code as RequestErrors, t), type: Types.ERROR })
        } else {
            setOpenSnackbar({ ...openSnackbar, open: true, message: option !== ScheduleEnumType.SERIE ? t('schedule.modal.editSuccessSchedule') : t('schedule.modal.editSuccessSerie'), type: Types.SUCCESS })
            setTimeout(() => {
                navigate('/dashboard/calendar');
            }, 3000);
        }
        setLoadSubmit(false)
        closeModal()

    }

    useEffect(() => {

        if (hasInitialized) return;

        setSelectedDays([DaysWeek.MONDAY, DaysWeek.TUESDAY, DaysWeek.WEDNESDAY, DaysWeek.THURSDAY, DaysWeek.FRIDAY, DaysWeek.SATURDAY, DaysWeek.SUNDAY])
        setData(prev => ({
            ...prev, from: null, to: null, startDateDaily: null, endDateDaily: null, fromDateDaily: null,
            toDateDaily: null, fromDateCycli: null, toDateCycli: null, startDate: null, duration: null,
            endDate: null, dayOfWeek: null, fromDateWeekly: null, toDateWeekly: null, durationCycli: null
        }))
        setStartDate(undefined)
    }, [data.frequency])

    useEffect(() => {
        loadData()
    }, [id])

    const getSection = () => {
        let caseSection = <></>
        switch (section) {
            case SectionType.Unity:
                caseSection = <Box sx={styles.hg100}>
                    <Box sx={styles.hg90}>
                        <Box sx={styles.headerLeft}>
                            <IconButton onClick={() => { setSection(SectionType.IndexSerie) }}>{icons('arrow-left-fill')}</IconButton>
                            <Typography>{t('schedule.assigned.backToEdit')}</Typography>
                        </Box>
                        <SelectTables
                            colors={colors}
                            filterRow={filterRow}
                            handleInformation={(e) => {
                                setSelected({
                                    ...selected,
                                    stores: e.checks,
                                })
                                setFlagStore(true)
                            }}
                            header={{ title: t('schedule.filter.filterStore.titleOnlyOne'), search: t('schedule.filter.filterStore.search') }}
                            initialFilterValues={initialFilterValues}
                            t={t}
                            table={tableStores}
                            defaultChecks={selected.stores}
                            isLoading={isLoading}
                        />
                    </Box>
                    <Box sx={styles.buttonsContainer}>
                        <Button onClick={() => { setSection(SectionType.IndexSerie) }}>{t('general.cancel')}</Button>
                        <Button className="next" variant="contained" onClick={() => { setSection(SectionType.IndexSerie) }}>
                            {t('general.continue')}
                        </Button>
                    </Box>
                </Box>
                break
            case SectionType.Questionarie:
                caseSection = <Box sx={styles.hg100}>
                    <Box sx={styles.hg90}>
                        <Box sx={styles.headerLeft}>
                            <IconButton onClick={() => { setSection(SectionType.IndexSerie) }}>{icons('arrow-left-fill')}</IconButton>
                            <Typography>{t('schedule.assigned.backToEdit')}</Typography>
                        </Box>
                        <SelectTables
                            colors={colors}
                            filterRow={filterRow}
                            handleInformation={(e) => {
                                setSelected({
                                    ...selected,
                                    questionnaire: e.checks,
                                })
                            }}
                            header={{ title: t('schedule.filter.filterQuestionnaire.titleOnlyOne'), search: t('schedule.filter.filterQuestionnaire.search') }}
                            initialFilterValues={initialFilterValues}
                            t={t}
                            table={tableQuestionnarie}
                            defaultChecks={selected.questionnaire}
                            isLoading={isLoading}
                        />
                    </Box>
                    <Box sx={styles.buttonsContainer}>
                        <Button onClick={() => { setSection(SectionType.IndexSerie) }}>{t('general.cancel')}</Button>
                        <Button className="next" variant="contained" onClick={() => { setSection(SectionType.IndexSerie) }}>
                            {t('general.continue')}
                        </Button>
                    </Box>
                </Box>
                break
            case SectionType.IndexSerie:
                caseSection = <ConfigCalendarSerie
                    data={data}
                    errors={errors}
                    userOption={userOption}
                    assignedChildren={assignedChildren}
                    onChange={onChange}
                    selectedText={selectedText}
                    setModal={setModal}
                    disabled={disabled}
                    scheduleType={option}
                    setSection={setSection}
                    mimTimeZone={mimTimeZone}
                    refRange={refRange}
                    selectedDays={selectedDays}
                    setData={setData}
                    setSelectedDays={setSelectedDays}
                    setStartDate={setStartDate}
                    startDate={startDate}
                    maxToDay={data.maxToDay}
                    secondText={t('schedule.assigned.unity')}
                    secondButonTitle={t('schedule.buttons.selectOtherUnity')}
                    titelForm={t('schedule.assigned.visit')}
                    firstInput={inputModel}
                    stringToNavigate='/dashboard/calendar'
                />
                break
            default:
                caseSection = <></>
        }

        return caseSection
    }

    const getDataTables = async (cancelLoading?: boolean) => {

        setIsLoading(true)

        getStores({ t })
            .then((data: any) => {
                setTableStores(data)
                if (!cancelLoading) {
                    setIsLoading(false)
                }
            })
            .catch(() => { })
        setTableQuestionnarie(await getQuestionnarie(t))
    }

    const [userOption, setUserOption] = useState<{ [x: string]: InputModel }>({
        user: {
            label: 'general.tags.user',
            translate: true,
            name: 'user',
            type: 'select',
            value: null,
            items: [],
            validate: {
                required: true,
            },
            size: {
                xl: 12,
                lg: 12,
                md: 12,
                sm: 12,
            },
        },
    })

    const getUserByStoreIds = async () => {
        const data = await storeServices.getAllStoresWithAgents({ queary: `?stores_ids=${selected.stores[0]}` })

        const users = (data[0].users || []).map(user => ({
            id: user.id,
            firstName: user.firstName,
            lastName: user.lastName
        }));

        const loggedUser = {
            id: state.id as number,
            firstName: state.firstName as string,
            lastName: state.lastName as string,
        };
        const isLoggedUserIncluded = users.some(user => user.id === loggedUser.id);

        if (!isLoggedUserIncluded) {
            users.push(loggedUser);
        }

        const newItems = users.map(user => ({
            label: `${user.firstName.trim()} ${user.lastName.trim()}`,
            value: user.id
        }));

        setUserOption(prev => ({ ...prev, user: { ...prev.user, items: newItems } }))
    }

    const lookForInvalidateFields = () => {
        if (option == ScheduleEnumType.UNIQUE || option == ScheduleEnumType.SERIE) {
            if (data?.frequency == FrequencyEnum.UNIQUE) {
                return !(
                    Boolean(data?.from) && Boolean(data?.to) && Boolean(data?.frequency) &&
                    dayjs(data?.to).isAfter(dayjs(data.from).add(5, 'minute')) //&&
                    //dayjs(data?.to).isAfter(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value,)).add(5, 'minute'))
                )
            }
            if (data?.frequency == FrequencyEnum.DAYLI) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.startDateDaily) && Boolean(data?.endDateDaily) && Boolean(data?.fromDateDaily) && Boolean(data?.toDateDaily) &&
                    dayjs(data?.endDateDaily).isAfter(dayjs(data.startDateDaily).add(4, 'minute')) &&
                    dayjs(data?.toDateDaily).isAfter(dayjs(data.fromDateDaily))
                )
            }
            if (data?.frequency == FrequencyEnum.WEEKLY) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.startDate) && Boolean(data?.duration) && Boolean(data?.dayOfWeek) && Boolean(data?.endDate) && Boolean(data?.fromDateWeekly) && Boolean(data?.toDateWeekly) &&
                    dayjs(data?.toDateWeekly).isAfter(dayjs(data.fromDateWeekly).add(6, 'days')) &&
                    selectedDays.includes(data?.dayOfWeek)
                )
            }

            if (data?.frequency == FrequencyEnum.CYCLIC) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.startDate) && Boolean(data?.duration) && Boolean(data?.endDate) && Boolean(data?.fromDateCycli) && Boolean(data?.toDateCycli) &&
                    dayjs(data?.toDateCycli).isAfter(dayjs(data.fromDateCycli))
                    //validar que sea una semana despues
                )
                //&&
                //validar que sea una semana despues
            }

        }

        if (option == ScheduleEnumType.RECURRENT) {
            if (data?.frequency == FrequencyEnum.DAYLI) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.from) && Boolean(data?.to) && /* Boolean(data?.toDateDaily) && */
                    dayjs(data?.to).isAfter(dayjs(data.from).add(4, 'minute')) /* &&
                    dayjs(data?.toDateDaily).isAfter(dayjs(data.fromDateDaily)) */
                )
            }
            if (data?.frequency == FrequencyEnum.WEEKLY) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.from) && Boolean(data?.to) /* &&  *//* Boolean(data?.dayOfWeek) && Boolean(data?.endDate) && Boolean(data?.fromDateWeekly) && Boolean(data?.toDateWeekly) && */
                    /* dayjs(data?.to).isAfter(dayjs(data.from).add(6, 'days'))  *//* &&
                    selectedDays.includes(data?.dayOfWeek) */
                )
            }

            if (data?.frequency == FrequencyEnum.CYCLIC) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.from) && Boolean(data?.to) /* && Boolean(data?.endDate) && Boolean(data?.fromDateCycli) && Boolean(data?.toDateCycli) &&
                    dayjs(data?.toDateCycli).isAfter(dayjs(data.fromDateCycli)) */
                    //validar que sea una semana despues
                )
                //&&
                //validar que sea una semana despues
            }
        }

        return false
        //Aca van las validaciones del disable

    }

    const disabled = () => {
        if (!selected.questionnaire || !selected.stores || !data.user || !selectedText.questionnaire) return true
        if (data?.openQuestionnaire) return false
        if (Object.values(errors).some((item: any) => !!item)) return true
        return lookForInvalidateFields()
    }

    useEffect(() => {
        getUserByStoreIds()
        if (flagStore) {
            setData(prev => ({
                ...prev,
                user: null
            }))
        }
    }, [selected.stores])

    useEffect(() => {
        getDataTables()
    }, [id])

    useEffect(() => {
        const clickedRowStore = tableStores.row.find(row => row.id === selected.stores[0]);
        const clickedRowQuestionarie = tableQuestionnarie.row.find(row => row.id === selected.questionnaire[0]);
        setSelectedText({ questionnaire: clickedRowQuestionarie?.quest_name, stores: `${clickedRowStore?.keyCode} - ${clickedRowStore?.name}` })
        const theBiggest = clickedRowStore?.storeTimeZone ?? Constants.defaultTimeZoneObject;
        setmimTimeZone(theBiggest)
    }, [selected, tableQuestionnarie, tableStores])


    return (
        <> {(loadingLocal || isLoading) ?
            <Loader />
            :
            <>
                <Box sx={styles.body}>{getSection()}</Box>
                <SimpleModal
                    open={!!modal.open}
                    next={modal?.confirm}
                    back={closeModal}
                    close={closeModal}
                    description={modal.description}
                    buttonText={t('general.confirm')}
                    cancelText={t('general.cancel')}
                    title={modal.title}
                    sx={{ width: '470px' }}
                    children={modal.children}
                    loadingButton={modal.isLoading}
                    isLoading={loadSubmit}
                />
                <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />
            </>
        }

        </>

    )
}

export { EditSerie }
